import * as React from 'react'
import { trackTweetCardClick } from 'events/index'
import styles from './TweetCard.module.scss'

const TweetCard = (props) => {
	return (
		<div className={styles.root}>
			<a
				href={props.link}
				role="link"
				aria-label={props.name + 'Open in new Window'}
				target="_blank"
				rel="noreferrer"
				onClick={() => trackTweetCardClick(props.link)}
			>
				<div className={styles.box}>
					<img
						className={styles.icon}
						src="https://eightsleep.imgix.net/twitter_icon_a792d34f-3b41-40b0-8863-2ba2c7958a65.jpg?v=1669632066"
						alt="Twitter icon"
					/>
					<img
						className={`${styles.pic} fw`}
						src={props.image}
						alt={props.altText ? props.altText : ''}
					/>
					<p className={styles.name}>{props.name}</p>
					<p className={styles.handle}>{props.handle}</p>
					<p className={styles.content}>
						<span dangerouslySetInnerHTML={{ __html: props.text }} />
						{props.readMore && (
							<div className={styles.rm}>
								... <span>Read More</span>
							</div>
						)}
					</p>
					<p className={styles.date}>{props.date}</p>
				</div>
			</a>
		</div>
	)
}

export default TweetCard
